module.exports = __webpack_public_path__ + "img/cathedral_small.cacd5d72.png";